import {useQuery} from "react-query";
import ShipmentCountByDestinationRegionApi from "./ShipmentCountByDestinationRegion.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useShipmentCountByDestinationRegion(query:IWidgetQuery){
    return useQuery(["fetchShipmentCountByDestinationRegion", query], ShipmentCountByDestinationRegionApi.getData);
}